import { render } from "./BackOfficeSales.vue?vue&type=template&id=be76a53a"
import script from "./BackOfficeSales.vue?vue&type=script&lang=js"
export * from "./BackOfficeSales.vue?vue&type=script&lang=js"
script.render = render

export default script